import styled from 'styled-components';

import { breakpoints, colors, functions, zIndex } from '../../ui/variables';

const showModal = {
  padding: {
    iphone: functions.responsive.vw(
      32,
      80,
      breakpoints.iphone.width,
      breakpoints.ipad.width
    ),
    ipad: functions.responsive.vw(
      48,
      80,
      breakpoints.ipad.width,
      breakpoints.hd.width
    ),
    hd: functions.responsive.vw(
      24,
      28,
      breakpoints.ipad.width,
      breakpoints.wxgaPlus.width
    ),
  },
};

export const Report3dVideoStyle = styled.div`
  height: 100%;

  .show-modal {
    background-color: ${colors.black};
    border-radius: 12px;
    display: block;
    padding: ${showModal.padding.iphone};
    position: relative;
    width: 100%;

    @media (min-width: ${breakpoints.ipad.width}px) {
      padding: ${showModal.padding.ipad};
    }

    @media (min-width: ${breakpoints.hd.width}px) {
      padding: ${showModal.padding.hd};
    }
  }

  .report-image-file {
    display: block;
    height: auto;
    width: 100%;
  }

  .zoom-icon {
    bottom: 20px;
    display: block;
    height: 20px;
    position: absolute;
    right: 20px;
    width: 20px;

    svg {
      fill: ${colors.white};
    }
  }

  .image3d-modal-container {
    display: flex;
    flex-wrap: nowrap;
    height: 82.4vh;
    max-height: 890px;
    max-width: 1516px;
    padding: 36px 40px;
    width: 79vw;

    .image3d-modal-carousel {
      border-radius: 14px;
      display: block;
      height: 100%;
      max-width: 100%;
      min-width: 100%;
      overflow: hidden;
      position: relative;

      .modal-carousel-navigation-step {
        ${zIndex.hills};
        background-color: ${functions.rgba(colors.white, 0)};
        bottom: 0;
        position: absolute;
        top: 0;
        transition: background-color 300ms;
        width: 80px;

        &.last-image {
          left: 0;

          .icon {
            transform: translate(-50%, -50%) rotate(90deg);
          }
        }

        &.next-image {
          right: 0;

          .icon {
            transform: translate(-50%, -50%) rotate(-90deg);
          }
        }

        &:hover {
          background-color: ${functions.rgba(colors.white, 0.1)};
        }

        .icon {
          display: block;
          height: 20px;
          left: 50%;
          position: absolute;
          top: 50%;
          width: 20px;

          svg {
            display: block;
            fill: ${colors.white};
            height: auto;
            width: 100%;
          }
        }
      }

      .modal-carousel-content {
        display: flex;
        flex-wrap: nowrap;
        height: 100%;

        .carousel-content-item {
          align-items: center;
          background-color: ${colors.black};
          display: flex;
          height: 100%;
          justify-content: center;
          max-width: 100%;
          min-width: 100%;
          padding: 0 80px;

          .content-item-image {
            display: block;
            height: auto;
            max-height: 100%;
            max-width: 100%;
            width: auto;
          }
        }
      }
    }
  }

  .not-available-warning {
    align-items: center;
    background-color: ${colors.mostlyWhite};
    border-radius: 12px;
    display: flex;
    height: 100%;
    justify-content: center;
    padding: 20px;
  }
`;
